var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconChevronLeft = function SvgIconChevronLeft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    stroke: "var(--icon-main, currentColor)",
    strokeWidth: 2,
    strokeLinecap: "square",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 4L4 8L8 12",
    stroke: "var(--icon-accent)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11 9L12 8L11 7L10 8L11 9Z"
  })));
};
export default SvgIconChevronLeft;